import { useEffect, useState } from 'react';
import { ApiError, apiRequest, backendAuthEventName, getBackendToken } from '../api/client';
import { pageCacheScope } from './pageCache';

const cooldowns = new Map();
const EVENT = 'amposter:follow-cooldown';
const scope = () => pageCacheScope(getBackendToken()) || getBackendToken();
const remaining = (key = scope()) => Math.max(0, Math.ceil(((cooldowns.get(key)?.until || 0) - Date.now()) / 1000));

export async function followWithCooldown(userId) {
  const key = scope(), wait = remaining(key);
  if (wait) {
    const previous = cooldowns.get(key).error;
    throw new ApiError(previous.message, { status: 429, code: previous.code, details: { retryAfterSeconds: wait } });
  }
  cooldowns.delete(key);
  try { return await apiRequest(`/api/v1/profiles/${userId}/follow`, { method: 'POST' }); }
  catch (error) {
    if (error.status === 429 && ['FOLLOW_RATE_LIMITED', 'FOLLOW_IP_BLOCKED'].includes(error.code) && error.retryAfterSeconds > 0) {
      cooldowns.set(key, { until: Date.now() + error.retryAfterSeconds * 1000, error });
      window.dispatchEvent(new Event(EVENT));
    }
    throw error;
  }
}

export function useFollowCooldown() {
  const [seconds, setSeconds] = useState(() => remaining());
  const ticking = seconds > 0;
  useEffect(() => {
    const update = () => setSeconds(remaining());
    update();
    window.addEventListener(EVENT, update);
    window.addEventListener(backendAuthEventName, update);
    const timer = ticking ? window.setInterval(update, 1000) : null;
    return () => {
      window.removeEventListener(EVENT, update);
      window.removeEventListener(backendAuthEventName, update);
      if (timer) window.clearInterval(timer);
    };
  }, [ticking]);
  return seconds;
}

export const followWaitLabel = (seconds, ar) => `${ar ? 'انتظر' : 'Wait'} ${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
